module.exports = __webpack_public_path__ + "static/media/NoData.740a7e83.svg";